// extracted by mini-css-extract-plugin
export default {"inputContainer":"Form_inputContainer__6Fe-Y","containerLogo":"Form_containerLogo__1vBJN","selected":"Form_selected__XfBfz","linkButton":"Form_linkButton__8HcL2"};